// const colors = ["white", "beige", "red"]
const styles = ["rustic", "romantic", "accent", "lounge", "bar"]
const locations = ["beach", "dining", "outdoor", "living", "bedroom", "office", "decor"]
const furnitures = ["armchair", "chair", "sofa", "table", "stool", "couch", "pillow", "rug", "bench", "lighting"]

const getIndexKeywords = () => {
  const keywords = []
  for (const style of styles)
    for (const furniture of furnitures) keywords.push(`${style} ${furniture}`)
  return keywords
}

const getSuggestions = (query = "") => {
    const qWords = query.split(' ')
    if(qWords?.length < 2 || !styles.includes(qWords[0]) || !furnitures.includes(qWords[1])) return

    const keywords = []
    for (const location of locations)
        keywords.push(`${qWords[0]} ${location} ${qWords[1]}`)

    return keywords
  }

export { getIndexKeywords, getSuggestions }